import { Upload, SqlResults, CacheId } from 'shared/models';

export const Actions = {
    SQL_REQUEST: 'SQL_REQUEST',
    SQL_SUCCESS: 'SQL_SUCCESS',
    SQL_FAILURE: 'SQL_FAILURE',

    CACHE_CLI_REQUEST: 'CACHE_CLI_REQUEST',
    CACHE_CLI_SUCCESS: 'CACHE_CLI_SUCCESS',
    CACHE_CLI_FAILURE: 'CACHE_CLI_FAILURE',

    GET_UPLOADS_REQUEST: 'GET_UPLOADS_REQUEST',
    GET_UPLOADS_SUCCESS: 'GET_UPLOADS_SUCCESS',
    GET_UPLOADS_FAILURE: 'GET_UPLOADS_FAILURE',

    UPLOAD_REQUEST: 'UPLOAD_REQUEST',
    UPLOAD_PROGRESS: 'UPLOAD_PROGRESS',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'UPLOAD_FAILURE',
    DISMISS_UPLOAD_ERROR: 'DISMISS_UPLOAD_ERROR',

    DELETE_UPLOAD_REQUEST: 'DELETE_UPLOAD_REQUEST',
    DELETE_UPLOAD_EARLY: 'DELETE_UPLOAD_EARLY',
    DELETE_UPLOAD_SUCCESS: 'DELETE_UPLOAD_SUCCESS',
    DELETE_UPLOAD_FAILURE: 'DELETE_UPLOAD_FAILURE',
};

export const sqlRequest = (payload: { sql: string; params?: any[] }) => ({
    type: Actions.SQL_REQUEST,
    payload,
});
export const sqlSuccess = (results: SqlResults[]) => ({
    type: Actions.SQL_SUCCESS,
    payload: results,
});
export const sqlFailure = (err: string) => ({
    type: Actions.SQL_FAILURE,
    payload: err,
    error: true,
});

export const cacheCliRequest = (cmd: string, meta: { cacheId: CacheId }) => ({
    type: Actions.CACHE_CLI_REQUEST,
    payload: cmd,
    meta,
});
export const cacheCliSuccess = (results: any, meta: { cacheId: CacheId }) => ({
    type: Actions.CACHE_CLI_SUCCESS,
    payload: results,
    meta,
});
export const cacheCliFailure = (err: string, meta: { cacheId: CacheId }) => ({
    type: Actions.CACHE_CLI_FAILURE,
    payload: err,
    error: true,
    meta,
});

export const getUploadsRequest = () => ({
    type: Actions.GET_UPLOADS_REQUEST,
});
export const getUploadsSuccess = (uploads: Upload[]) => ({
    type: Actions.GET_UPLOADS_SUCCESS,
    payload: uploads,
});
export const getUploadsFailure = (err: Error) => ({
    type: Actions.GET_UPLOADS_FAILURE,
    payload: err,
    error: true,
});

export const uploadRequest = (file: File) => ({
    type: Actions.UPLOAD_REQUEST,
    payload: file,
});
export const uploadProgress = (progress: number) => ({
    type: Actions.UPLOAD_PROGRESS,
    payload: progress,
});
export const uploadSuccess = (upload: Upload) => ({
    type: Actions.UPLOAD_SUCCESS,
    payload: upload,
});
export const uploadFailure = (error: string) => ({
    type: Actions.UPLOAD_FAILURE,
    payload: error,
    error: true,
});
export const dismissUploadError = () => ({
    type: Actions.DISMISS_UPLOAD_ERROR,
});

export const deleteUploadRequest = (filename: string) => ({
    type: Actions.DELETE_UPLOAD_REQUEST,
    payload: filename,
});
export const deleteUploadEarly = (filename: string) => ({
    type: Actions.DELETE_UPLOAD_EARLY,
    payload: filename,
});
export const deleteUploadSuccess = (filename: string) => ({
    type: Actions.DELETE_UPLOAD_SUCCESS,
    meta: { filename },
});
export const deleteUploadFailure = (err: Error, upload: Upload) => ({
    type: Actions.DELETE_UPLOAD_FAILURE,
    payload: err,
    error: true,
    meta: { upload },
});
